import { useEffect } from 'react';
import { GridApi, GridOptions } from 'ag-grid-community';
import { AnyRow, UseControlledAGGridProps } from '../types';

export const usePagination = <
  RowData,
  FullWidthRowData = never,
  RowId extends string = string,
>(
  props: UseControlledAGGridProps<RowData, FullWidthRowData, RowId>,
  api: GridApi | null
) => {
  const pagination = props.pagination;

  useEffect(() => {
    if (!api || pagination === undefined) {
      return;
    }

    api.paginationGoToPage(pagination.currentPage - 1);
    api.updateGridOptions({
      paginationPageSize: pagination.pageSize,
    });
  }, [api, pagination]);

  const paginationGridProps:
    | GridOptions<AnyRow<RowData, FullWidthRowData, RowId>>
    | undefined = pagination
    ? {
        pagination: true,
        paginationPageSize: pagination.pageSize,
        suppressPaginationPanel: true,
      }
    : undefined;

  return {
    paginationGridProps,
  };
};
